import { useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";

const STATUS = [
  {
    title: 'Yes',
    value: false,
  },
  {
    title: 'No',
    value: true 
  }
]

export default function FirstFellowSwitch({ row, reportId, lockStatus = false, refetchReports }) {
  const [switchStatus, setSwitchStatus] = useState(false);
  const [selected, setSelected] = useState(STATUS[0].value)

  useMemo(() => setSelected(!switchStatus), [switchStatus])

  const handleChange = async () => {
    setSwitchStatus(!switchStatus)
    // if (!row?.needsReview) {
    //   const variables = {
    //     variables: {
    //       reportId: reportId
    //     }
    //   }
      
    //   if (selected) {
    //     await lockReport(variables)
    //     refetchReports()
    //   } else {
    //     if (row.name === 'Brain & Memory') {
    //       dispatch(
    //         openModal({
    //           currentModal: 'BRAIN_MEMORY_CONSENT_MODAL',
    //           modalProps: {
    //             onConfirm: async () => {
    //               await unlockReport(variables)
    //               refetchReports()
    //             }
    //           }
    //       }))
    //     } else {
    //       await unlockReport(variables)
    //       refetchReports()
    //     }
    //   }
    // }
  }

  return (
    <Box 
      sx={{
        bgcolor: selected ? 'primary.mediumGreen' : 'primary.mediumGray',
        border: '0px solid',
        borderRadius: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        height: '31px',
        width: !selected ? '80px' : '80px',
        padding: selected ? '4px 4px 4px 8px' : '4px 8px 4px 4px',
        position: 'relative'
      }}
      onClick={handleChange}
    >
      {STATUS.map(option => (
        <Box
          key={option.title}
          sx={{
            minWidth: selected === option.value ? '22px' : 'auto',
            height: selected === option.value ? '22px' : '100%',
            borderRadius: selected === option.value ? '50%' : '0px',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: selected === option.value ? 'white' : 'transparent',
          }}
        >
          <Typography
            key={option.value}
            variant="h4"
            sx={{
              color: 'primary.white',
              whiteSpace: 'nowrap',
              display: selected === option.value ? 'none' : 'block',
              mr: option.title === 'Unlocked' ? '4px' : 0
            }}
          >
            {option.title}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}